export default __webpack_public_path__ + "static/media/image21.250a3a7a.jpg";